import styled from 'styled-components';
import { Modal } from './comps';

export const StyledModal = styled(Modal)`
  width: 566px;
  min-height: 200px;

  .gear {
    display: flex;
    justify-content: center;
    &__icon {
      color: ${({ theme }) => theme.colors.gp1};
      font-size: 35px;
    }
  }

  .text-center {
    display: block;
    text-align: center !important;
  }

  .subtitle {
    color: ${({ theme }) => theme.colors.davysGrey};
    padding: 0 20px;
  }

  .buttons {
    padding: 0 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 17px;
  }
`;
